import React, { Component } from "react";
import OwCheckbox from "../../../shared/OwCheckbox/OwCheckbox";
import OwTranslate from "../../../shared/OwTranslate/OwTranslate";
import * as _ from "lodash-es";
import IOrder_Item from "../../../../models/IOrder_Item";
import IOrder from "../../../../models/IOrder";
import ISupplierModel from "../../../../models/ISupplierModel";
import { CatalogItemDescription } from "../../../shared/CatalogItemDescription/CatalogItemDescription";
import OwS3ImageViewer from "../../../shared/OwS3ImageViewer/OwS3ImageViewer";
import { OwBarcode } from "../../../shared/OwBarcode/OwBarcode";

type Props = {
    order: IOrder;
    supplierModel: ISupplierModel;
    orderItem: IOrder_Item;
    showItemPhoto: boolean;
    showOrderQty: boolean;
    showShipQty: boolean;
    showDropshipment: boolean;
    showSku: boolean;
    showUpc: boolean;
    showLot: boolean;
    hideSkuCol: boolean;
    showItemLocation: boolean;
    showUom: boolean;
};

type State = {
    isDropshipped: boolean;
};

class PackingListItemRow extends Component<Props, State> {
    readonly state: State = {
        isDropshipped: false,
    };

    toggleDropshipped = () => {
        this.setState({
            isDropshipped: !this.state.isDropshipped,
        });
    };

    render() {
        const catalogItem = this.props.orderItem.Catalog_Item!;

        let qty = this.props.orderItem.total_qty;

        if (!qty) {
            qty = Number(this.props.orderItem.qty);
        }

        if (this.props.orderItem.bonus_qty_frozen) {
            qty = Number(qty) + Number(this.props.orderItem.bonus_qty_frozen);
        } else if (this.props.orderItem.total_bonus_qty_frozen) {
            qty = Number(qty) + Number(this.props.orderItem.total_bonus_qty_frozen);
        }

        let note;

        if (!_.isNil(this.props.orderItem.note) && this.props.orderItem.note) {
            note = (
                <div>
                    <OwTranslate defaultMessage={"note"} id={"note"} />: {this.props.orderItem.note}
                </div>
            );
        }

        const barcodeOpts = {
            height: 75,
        };

        return (
            <tr>
                <td>{this.props.orderItem.item_no}</td>
                {this.props.showItemLocation ? (
                    <td>
                        <div>{this.props.orderItem.Catalog_Item?.row}</div>
                        <div>{this.props.orderItem.Catalog_Item?.bin}</div>
                    </td>
                ) : null}
                <td>
                    <div>{catalogItem.name}</div>
                    {this.props.showItemPhoto ? <OwS3ImageViewer catalogItem={catalogItem} /> : null}
                    {this.props.showUpc && catalogItem.upc && catalogItem.upc.length === 12 ? (
                        <div>
                            <OwBarcode format={"UPC"} value={catalogItem.upc} height={50} />
                        </div>
                    ) : null}
                </td>
                {this.props.hideSkuCol ? null : (
                    <td>
                        {this.props.showSku ? null : <div>{catalogItem.sku}</div>}
                        {this.props.showSku && catalogItem.sku?.length ? (
                            <div>
                                <OwBarcode format={"CODE128"} value={catalogItem.sku} height={50} />
                            </div>
                        ) : null}
                    </td>
                )}
                {this.props.showUom ? <td>{catalogItem.Unit_Of_Measurement?.abbreviation}</td> : null}
                <td>
                    <div className={"pre-wrap"}>
                        <CatalogItemDescription
                            catalogItem={catalogItem}
                            orderItem={this.props.orderItem}
                            priceGroup={this.props.order?.Price_Group}
                        />
                    </div>
                    <div>{note}</div>
                </td>
                {this.props.showLot ? <td className={"w-10"}></td> : null}
                <td className={"w-15 " + (this.props.showOrderQty ? "" : "d-none")}>{qty}</td>
                <td className={"w-15 " + (this.props.showShipQty ? "" : "d-none")}>
                    <span className={this.state.isDropshipped ? "d-none" : ""}>
                        <input type="number" min={0} max={qty} className={"form-control form-control-sm"} />
                    </span>
                    <span className={this.state.isDropshipped ? "" : "d-none"}>
                        <OwTranslate defaultMessage={"dropshipped"} id={"dropshipped"} />
                    </span>
                    <span className={(this.props.showDropshipment ? "" : "d-none") + " d-print-none"}>
                        <OwCheckbox label={"is_dropshipped"} name={"is_dropshipped"} fn={this.toggleDropshipped} />
                    </span>
                </td>
            </tr>
        );
    }
}

export default PackingListItemRow;
